var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.052,
    height: 5.493,
    viewBox: "830 63 9.052 5.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m834.174 68.348-4.028-4.029a.497.497 0 0 1 0-.703l.47-.47a.497.497 0 0 1 .702-.001l3.208 3.192 3.207-3.192a.497.497 0 0 1 .703 0l.47.47a.497.497 0 0 1 0 .704l-4.028 4.029a.498.498 0 0 1-.704 0Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon awesome-chevron-down"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/DropdownIcon.dbeb83dbfb856c8832dc01b8b00094fa.svg";
export { ForwardRef as ReactComponent };